var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal",
            class: { open: _vm.isOpen, fixedHeader: _vm.fixedHeader }
          },
          [
            _c("div", { staticClass: "modal__inner" }, [
              _c(
                "div",
                {
                  staticClass: "modal__close",
                  on: {
                    click: function($event) {
                      _vm.toggle(false)
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-times fa-3x",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm.title
                ? _c("header", { staticClass: "modal__header" }, [
                    _c("h3", { domProps: { innerHTML: _vm._s(_vm.title) } })
                  ])
                : _vm._e(),
              _c(
                "section",
                {
                  staticClass: "modal__content",
                  class: { "no-title": !_vm.title }
                },
                [_vm._t("default")],
                2
              )
            ])
          ]
        ),
        _vm.isOpen
          ? _c("div", {
              staticClass: "modal--overlay",
              on: {
                click: function($event) {
                  _vm.toggle(false)
                }
              }
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01bc5d9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01bc5d9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/Modal.vue
// module id = /5D6
// module chunks = 6 24 27 29